import { create } from "zustand";
import type { Notification, NotificationPagination } from "../types/notification";

interface NotificationState {
  notifications: Notification[];
  unreadCount: number;
  isPaused: boolean;
  preferences: Record<string, unknown> | null;
  pagination: NotificationPagination;

  setNotifications: (list: Notification[]) => void;
  addNotification: (item: Notification) => void;
  markRead: (notificationId: string) => void;
  markAllRead: () => void;
  setUnreadCount: (count: number) => void;
  decrementUnreadCount: () => void;
  setIsPaused: (isPaused: boolean) => void;
  setPreferences: (preferences: Record<string, unknown> | null) => void;
  setPagination: (pagination: NotificationPagination) => void;
}

const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  unreadCount: 0,
  isPaused: false,
  preferences: null,
  pagination: { page: 1, limit: 20, total: 0, totalPages: 1 },

  setNotifications: (list) => set({ notifications: list }),

  addNotification: (item) =>
    set((state) => ({
      notifications: [item, ...state.notifications],
      unreadCount: state.unreadCount + 1,
    })),

  markRead: (notificationId) =>
    set((state) => ({
      notifications: state.notifications.map((n) =>
        n.id === notificationId ? { ...n, isRead: true } : n,
      ),
    })),

  markAllRead: () =>
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, isRead: true })),
      unreadCount: 0,
    })),

  setUnreadCount: (count) => set({ unreadCount: count }),

  decrementUnreadCount: () =>
    set((state) => ({
      unreadCount: Math.max(0, state.unreadCount - 1),
    })),

  setIsPaused: (isPaused) => set({ isPaused }),

  setPreferences: (preferences) => set({ preferences }),

  setPagination: (pagination) => set({ pagination }),
}));

export default useNotificationStore;
